import React from 'react';
import ArticleAside from './ArticleAside';
import {i18n_t} from 'app/i18n';

export const Articles = ({hidePromotions}: {hidePromotions?: boolean}): React.ReactElement => <>
    <ArticleAside type="news" title={i18n_t('news_title')}/>
    {!hidePromotions && <ArticleAside type="promotions" title={i18n_t('promotions_title')}/>}
</>;
